<!-- 首页 top rank 排行榜 -->
<template>
  <div class="TopRank-Component">
    <ul class="top-rank-tablist">
      <li
        v-for="(tab, index) in tabList"
        :key="index"
        :class="[
          'top-rank-tab',
          { 'top-rank-tab--active': topRankActiveTab === index }
        ]"
        @click="topRankActiveTab = index"
      >
        <a class="top-rank-tab__beans" href="javascript:;">{{ tab }}</a>
      </li>
    </ul>
    <div class="top-rank-box">
      <ul>
        <li
          v-for="(item, index) in currentTopRank"
          :key="index"
          class="rank-item"
        >
          <p class="rank-num">{{ index + 1 }}</p>
          <div class="thumb">
            <img v-lazy="item.head_icon" :alt="item.nick_name" />
          </div>
          <div class="name-box">
            <p class="name-box__nick-name">{{ item.nick_name }}</p>
            <p class="name-box__beans-views-num">{{ item.value }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    weekGetRankList: {
      type: Array,
      default: () => []
    },
    weekSendRankList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    this.tabList = ['Beans', 'Views'];
    return {
      topRankActiveTab: 0
    };
  },
  computed: {
    currentTopRank() {
      const { topRankActiveTab, weekGetRankList, weekSendRankList } = this;
      return topRankActiveTab === 0 ? weekGetRankList : weekSendRankList;
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.TopRank-Component {
  background: #fff;
  border-radius: 4px;

  .top-rank-tablist {
    overflow: hidden;

    .top-rank-tab {
      float: left;
      width: 123px;
      height: 48px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      line-height: 22px;
      font-weight: 400;
      color: #8a8f99;

      &.top-rank-tab--active {
        font-weight: 600;
        color: #2f3033;

        &::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          margin: 0 auto;
          top: 35px;
          width: 12px;
          height: 4px;
          background: #00decb;
          border-radius: 3px;
        }
      }

      // a {
      // display: inline-block;
      // font-size: 14px;
      // font-weight: 500;
      // color: #2f3033;
      // line-height: 16px;

      // &::before {
      //   content: '';
      //   position: relative;
      //   top: 8px;
      //   float: left;
      //   display: block;
      //   width: 20px;
      //   height: 20px;
      // }
      // }

      // &__beans::before {
      //   background: url(~@assets/img/icon.png) -10px -513px no-repeat;
      // }

      // &__views::before {
      //   background: url(~@assets/img/icon2.png) -88px 0 no-repeat;
      // }
    }
  }

  .top-rank-box {
    height: 532px;
    padding-top: 13px;
    overflow: auto;
    box-sizing: content-box;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */

    .rank-item {
      height: 57px;
      overflow: hidden;

      &:nth-child(1) {
        .rank-num {
          margin-top: 6px;
          font-size: 0;
          background-image: url(~@assets/img/1.png);
        }
      }

      &:nth-child(2) {
        .rank-num {
          margin-top: 6px;
          font-size: 0;
          background-image: url(~@assets/img/2.png);
        }
      }

      &:nth-child(3) {
        .rank-num {
          margin-top: 6px;
          font-size: 0;
          background-image: url(~@assets/img/3.png);
        }
      }

      .rank-num {
        float: left;
        width: 22px;
        height: 22px;
        margin-top: 10px;
        margin-left: 11px;
        margin-right: 7px;
        text-align: center;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        font-size: 15px;
        font-weight: 500;
        color: #8a8f99;
        line-height: 18px;
      }

      .thumb {
        float: left;
        width: 32px;
        height: 32px;
        overflow: hidden;
        border-radius: 50%;
        margin-top: 2px;
        margin-right: 8px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .name-box {
        float: left;
        width: 125px;

        &__nick-name,
        &__beans-views-num {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &__nick-name {
          font-size: 14px;
          font-weight: 500;
          color: #2f3033;
          line-height: 16px;
        }

        &__beans-views-num {
          font-size: 12px;
          font-weight: 400;
          color: #ffbf00;
          line-height: 14px;
          margin-top: 4px;
          position: relative;
          padding-left: 14px;

          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 12px;
            height: 12px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            background-image: url(~@assets/img/bean.png);
          }
        }
      }
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
